<div class="d-flex w-100 h-100">
	<div class="mx-auto my-auto">
		<div class="d-flex">
			<input pInputText #promoCode name="promoCode" type="text" [(ngModel)]="promoCodeCode" class="kiosk-promo-code-entry-field" />
			<div class="my-auto ms-4">
				<fa-icon [icon]="['fad', 'magnifying-glass-dollar']" class="display-3" size="xl" (click)="onCodeEntry()"></fa-icon>
			</div>
		</div>

		<div class="display-3">
			<span *ngIf="!rejectionMessage">Enter your promo code</span>
			<span *ngIf="rejectionMessage" class="text-red">{{ rejectionMessage }}</span>
		</div>
	</div>
</div>
